import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: {
    title: '快速导航',
    links: [
      { label: '首页', to: '/' },
      { label: '电影', to: '/category/movie' },
      { label: '电视剧', to: '/category/tv' },
      { label: '动漫', to: '/category/anime' },
      { label: '综艺', to: '/category/variety' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '用户口碑', to: '/about' },
      { label: '联系我们', to: '/about' },
      { label: '常见问题', to: '/about' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '使用指南', to: '/about' },
      { label: '问题反馈', to: '/about' },
      { label: '服务条款', to: '/about' },
      { label: '隐私政策', to: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12 md:py-16">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4 group whitespace-nowrap">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-white"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 group-hover:text-primary-400 transition-colors">
                91影视
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              海量高清影视资源免费在线观看平台。电影、电视剧、动漫、综艺全覆盖，更新及时，无需注册。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          {[footerLinks.navigation, footerLinks.about, footerLinks.support].map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2018-2026 91影视 91yingshi.com 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            <span>京ICP备2026081001号-1</span>
            <span className="mx-2">|</span>
            <span>京公网安备 11010802020260号</span>
          </p>
        </div>
      </div>
    </footer>
  );
}